export interface Sublocation {
  sublocationId: string;
  warehouseId: string;
  sublocationName: string;
  isFinalLocation: boolean;
}
